import { Campaign } from "./campaign"
import { CampaignReport } from "./campaign_report"

export class NewClient {
    constructor(new_client) {
        this.campaign        = new Campaign(new_client);
        this.campaign_report = new CampaignReport(new_client.campaign_report);
    }
}